import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

const RouteNotFound = () => {
  const navigate = useNavigate();

  const backLink = useCallback(() => {
    navigate('/userinformations');
  }, [navigate]);

  return (
    <div>
      route not found <button onClick={backLink}>Back to home</button>
    </div>
  );
};

export default RouteNotFound;
